import { AfterViewInit, Component, OnInit, ViewEncapsulation, Output, EventEmitter, HostListener, ViewChild, ElementRef, DoCheck, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SessionStorageService } from "../../shared/services/session-storage.service";
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'pme-my-new-package',
    templateUrl: './my-new-package.component.html',
    styleUrls: ['./my-new-package.component.scss'],
    animations: [
        trigger("componentFade", [
            state("loaded", style({ opacity: 1 })),
            transition(":enter", [
                style({ opacity: 0 }),
                animate(500)
            ]),
            transition(":leave", [
                animate(500, style({ opacity: 0 }))
            ])
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class CheckoutMyNewPackageComponent  {
 
  classificationIdentifier: string;

  @Output() onPackageChangeSelected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private route: ActivatedRoute,
    private sessionStorageService: SessionStorageService,
  ){
    this.classificationIdentifier = this.sessionStorageService.getClassification(this.route);
  }
}